import { UserManager } from "oidc-client";

import getProfileFromToken from "./getProfileFromToken";

import awsExports from "../../aws-export";
import inMemoryJwt from "./inMemoryJwt";

const issuer = `https://cognito-idp.${awsExports.aws_project_region}.amazonaws.com/${awsExports.aws_user_pools_id}`;
const clientId = awsExports.aws_user_pools_web_client_id;
const redirectUri = `${window.location.protocol}//${window.location.host}/auth-callback`;
const oauth2Url = awsExports.aws_hosted_ui_url;
const logoutUri = `${window.location.protocol}//${window.location.host}`;

const userManager = new UserManager({
  authority: issuer,
  client_id: clientId,
  redirect_uri: redirectUri,
  response_type: "code",
  scope: "openid email profile", // Allow to retrieve the email and user name later api side
});

const cleanup = () => {
  // Remove the ?code&state from the URL
  window.history.replaceState(
    {},
    window.document.title,
    window.location.origin
  );
};

const authProvider = {
  login: async () => {
    // 1. Redirect to the issuer to ask authentication
    await userManager.signinRedirect();
    return; // Do not return anything, the login is still loading
  },
  logout: async () => {
    console.log('logout')
    // Remove the token from the local storage
    if (inMemoryJwt.getToken()) {
      inMemoryJwt.ereaseToken()
      console.log('logout url', `${oauth2Url}/logout?client_id=${clientId}&logout_uri=${logoutUri}`)
      // 2. Redirect to the issuer to ask logout
      window.location.href = `${oauth2Url}/logout?client_id=${clientId}&logout_uri=${logoutUri}`;
    }
    return Promise.resolve();
  },
  checkError: () => {
    console.log('checkError')
    // localStorage.removeItem("token");
    return Promise.resolve();
  },
  checkAuth: () => {
    const token = inMemoryJwt.getToken();

    if (!token) {
      return Promise.reject();
    }
    console.log('token')
    // This is specific to the Google authentication implementation
    const jwt = getProfileFromToken(token);
    const now = new Date();
    console.log('jwt', jwt)
    console.log('jwt expired', now.getTime() > jwt.exp * 1000)

    return now.getTime() > jwt.exp * 1000
      ? Promise.reject()
      : Promise.resolve();
  },
  getPermissions: () => Promise.resolve(),
  getIdentity: () => {
    const token = inMemoryJwt.getToken();
    const profile = getProfileFromToken(token);

    return Promise.resolve({
      id: profile.sub,
      fullName: profile.name,
      avatar: profile.picture,
    });
  },
  handleCallback: async () => {
    // We came back from the issuer with ?code infos in query params
    const { searchParams } = new URL(window.location.href);
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    console.log('code', code, 'state', state)

    if (!code || !state) {
      return Promise.resolve()
    }

    // We need to remove the ?code&state from the URL')

    // oidc-client uses localStorage to keep a temporary state
    // between the two redirections. But since we need to send it to the API
    // we have to retrieve it manually
    const stateKey = `oidc.${state}`;
    const { code_verifier } = JSON.parse(
      localStorage.getItem(stateKey) || "{}"
    );

    // Transform the code to a token via the API
    const params = {
      grant_type: "authorization_code",
      client_id: clientId,
      redirect_uri: redirectUri,
      code: code, code_verifier
    };

    let body = Object.keys(params)
      .map((key) => { return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]); })
      .join('&');
    const response = await fetch(`${oauth2Url}/oauth2/token`, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });

    console.log('get token response', response)

    if (!response.ok) {
      cleanup();
      return Promise.reject();
    }

    const token = await response.json();
    console.log('get token', token)

    inMemoryJwt.setToken(token.id_token);

    userManager.clearStaleState();
    cleanup();
    return Promise.resolve();
  },
};

export default authProvider;